import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Clock } from "lucide-react";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import {
  LOGO, NAV, ADDRESS, PHONE_DISPLAY, PHONE_TEL,
  INSTAGRAM_URL, INSTAGRAM_HANDLE, waLink, onCall, onWhatsApp,
} from "@/lib/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-ink border-t border-white/10 pt-16 pb-28 lg:pb-10">
      <div className="container-x grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2 max-w-md">
          <img src={LOGO} alt="DG Guinchos Jundiaí" className="h-16 w-auto" />
          <p className="mt-5 text-zinc-400">
            Serviço de guincho e transporte de veículos em Jundiaí e região.
            Atendimento 24 horas, todos os dias.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onWhatsApp("footer")}
            className="mt-5 inline-flex items-center gap-2 bg-wapp hover:bg-wapp-hover text-black font-display font-bold uppercase tracking-wider px-6 py-3 rounded-sm transition-all active:scale-95"
          >
            <WhatsAppIcon className="h-5 w-5" /> Chamar no WhatsApp
          </a>
        </div>

        <div>
          <h4 className="font-display text-xl font-bold text-white">Navegação</h4>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-zinc-400 hover:text-brand transition-colors">{n.label}</a>
              </li>
            ))}
            <li>
              <Link to="/politica-de-privacidade" className="text-zinc-400 hover:text-brand transition-colors">
                Política de Privacidade
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl font-bold text-white">Contato</h4>
          <ul className="mt-4 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="h-5 w-5 text-brand shrink-0" />
              <a href={`tel:${PHONE_TEL}`} onClick={() => onCall("footer")} className="text-zinc-300 hover:text-white">{PHONE_DISPLAY}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-5 w-5 text-brand shrink-0" />
              <span className="text-zinc-400">{ADDRESS.street} - {ADDRESS.district}, {ADDRESS.city}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-5 w-5 text-brand shrink-0" />
              <span className="text-zinc-400">Aberto 24 horas · 7 dias</span>
            </li>
            <li className="flex items-start gap-3">
              <Instagram className="h-5 w-5 text-brand shrink-0" />
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-white">{INSTAGRAM_HANDLE}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-zinc-500">© {year} DG Guinchos Jundiaí. Todos os direitos reservados.</p>
        <div className="flex items-center gap-4">
          <p className="text-xs text-zinc-600 hidden md:block">Guincho 24h em Jundiaí, Várzea Paulista, Campo Limpo Paulista, Itupeva e Louveira.</p>
          <Link to="/admin" data-testid="footer-admin-link" className="text-xs text-zinc-600 hover:text-brand transition-colors whitespace-nowrap">Acesso Admin</Link>
        </div>
      </div>
    </footer>
  );
};
